import React from 'react';
import {
    ArrayField,
    Datagrid,
    DateField,
    Filter,
    List,
    SelectInput,
    Show,
    SimpleShowLayout,
    TextField,
    TextInput,
} from 'react-admin';
import { BulkDeleteButtonDisable, CustomPagination, isGeEmployee } from './utils';
import { CardActions } from '@material-ui/core';
import CancelTransactionButton from './transactionButton/CancelTransactionButton';

const TransactionsPayPlusActions = ({ data, permissions }) => (
    <CardActions
        submitOnEnter={false}
        style={{ zIndex: 2, display: 'inline-block', float: 'right' }}
    >
        {isGeEmployee(permissions) && (
            <CancelTransactionButton
                record={data}
                transaction_type={'payplus'}
            />
        )}
    </CardActions>
);

const TransactionsPayPlusFilter = props => (
    <Filter {...props}>
        <SelectInput
            label="Поле"
            source="field"
            choices={[
                { id: 'id', name: 'Id' },
                { id: 'external_id', name: 'Id в PayPlus' },
                { id: 'original_external_id', name: 'Id родителя в PayPlus' },
                { id: 'order_id', name: 'Id заказа' },
                { id: 'type', name: 'Тип транзакции' },
                { id: 'profile_payment_method_id', name: 'Id метода оплаты' },
                { id: 'amount', name: 'Сумма транзакции' },
                { id: 'status', name: 'Статус транзакции' },
                { id: 'error_code', name: 'Код ошибки' },
                { id: 'external_created', name: 'Дата и время создания' },
                { id: 'external_auth', name: 'Дата и время авторизации' },
                { id: 'external_paid', name: 'Дата и время оплаты' },
                { id: 'external_canceled', name: 'Дата и время отмены' },
                { id: 'created', name: 'Время создания' },
                { id: 'updated', name: 'Последнее обновление' },
            ]}
            alwaysOn
        />
        <TextInput
            label="Поиск"
            source="q"
            alwaysOn
        />
    </Filter>
);

export const TransactionsPayPlusList = props => (
    <List
        {...props}
        filters={<TransactionsPayPlusFilter />}
        bulkActionButtons={<BulkDeleteButtonDisable />}
        pagination={<CustomPagination />}
    >
        <Datagrid rowClick="show">
            <TextField
                label="Id"
                source="id"
            />
            <TextField
                label="Id в PayPlus"
                source="external_id"
            />
            <TextField
                label="Id заказа"
                source="order_id"
            />
            <TextField
                label="Тип"
                source="type"
            />
            <TextField
                label="Id метода оплаты"
                source="profile_payment_method_id"
            />
            <TextField
                label="Сумма"
                source="amount"
            />
            <TextField
                label="Оставшаяся сумма захвата"
                source="amount_capturable"
            />
            <TextField
                label="Валюта"
                source="currency"
            />
            <TextField
                label="Описание"
                source="description"
            />
            <TextField
                label="Статус"
                source="status"
            />
            <TextField
                label="Код ошибки"
                source="error_code"
            />
            <TextField
                label="Сообщение ошибки"
                source="error_message"
            />
            <DateField
                label="Дата и время создания"
                source="external_created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время авторизации"
                source="external_auth"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время платежа"
                source="external_paid"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время отмены"
                source="external_canceled"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Последнее обновление"
                source="updated"
                showTime
                locales="ru-RU"
            />
        </Datagrid>
    </List>
);

export const TransactionsPayPlusShow = ({ permissions, ...props }) => (
    <Show
        {...props}
        actions={<TransactionsPayPlusActions permissions={permissions} />}
    >
        <SimpleShowLayout>
            <TextField
                label="Id"
                source="id"
            />
            <TextField
                label="Id в PayPlus"
                source="external_id"
            />
            <TextField
                label="Id заказа"
                source="order_id"
            />
            <TextField
                label="Тип"
                source="type"
            />
            <TextField
                label="Id родителя в PayPlus"
                source="original_external_id"
            />
            <TextField
                label="Id платежной страницы в PayPlus"
                source="payment_page_request_uid"
            />
            <TextField
                label="Id метода оплаты"
                source="profile_payment_method_id"
            />
            <TextField
                label="Сумма"
                source="amount"
            />
            <TextField
                label="Оставшаяся сумма захвата"
                source="amount_capturable"
            />
            <TextField
                label="Валюта транзакции"
                source="currency"
            />
            <TextField
                label="Описание"
                source="description"
            />
            <TextField
                label="Статус"
                source="status"
            />
            <TextField
                label="Код ошибки"
                source="error_code"
            />
            <TextField
                label="Сообщение ошибки"
                source="error_message"
            />
            <DateField
                label="Дата и время создания"
                source="external_created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время авторизации"
                source="external_auth"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время платежа"
                source="external_paid"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Дата и время отмены"
                source="external_canceled"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Время создания"
                source="created"
                showTime
                locales="ru-RU"
            />
            <DateField
                label="Последнее обновление"
                source="updated"
                showTime
                locales="ru-RU"
            />
            <ArrayField
                label="История статусов"
                source="status_history"
            >
                <Datagrid>
                    <TextField
                        label="Статус"
                        source="status"
                    />
                    <TextField
                        label="Код ошибки"
                        source="code"
                    />
                    <TextField
                        label="Причина отказа"
                        source="decline_code"
                    />
                    <TextField
                        label="Время создания в PayPlus"
                        source="remote_created"
                    />
                    <TextField
                        label="Локальное время создания"
                        source="created"
                    />
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);
